import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { User, UserAction, UserStep } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserActions',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore<ShiftCMSState & { us: UsersState }>();

const actions = computed<UserAction[]>(() => store.state.us.userActions);
const steps = computed<UserStep[]>(() => store.state.us.userSteps);

const headers = [
  { title: 'Action', key: 'action.title' },
  { title: 'Status', key: 'completed' },
  { title: 'Completed Steps', key: 'steps' },
  { title: 'Options', key: 'options' },
];

function deleteUserAction(id: number) {
  store.dispatch(UsersActions.DeleteUserAction, {
    id,
    userId: props.user.id,
    stepIds: props.user.steps.map((s) => s.id),
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mt-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Actions")
        ])),
        _: 1
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        headers: headers,
        items: actions.value,
        itemsPerPage: "10",
        hover: ""
      }, {
        "item.completed": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(value ? 'Completed' : 'Open'), 1)
        ]),
        "item.options": _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            density: "compact",
            icon: "mdi-delete-outline",
            onClick: ($event: any) => (deleteUserAction(item.id))
          }, null, 8, ["onClick"])
        ]),
        "item.steps": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(steps.value.filter((us) =>
            item.action.steps.map((s) => s.id).includes(us.step.id),
          ).length) + " / " + _toDisplayString(item.action.steps.length), 1)
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})